import { useTranslation } from "react-i18next";
import { Button, Form, message, Modal, Skeleton, Typography } from "antd";
import CustomCard from "../../../custom-card/CustomCard";

import { ConstructCourseDetailType, Section } from "../../../../types/course-construction";
import { formatDate } from "../../../../utils/converDate";
import "./course-construct.scss";

import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { putUpdateCoursePosition, syncSource } from "../../../../service/course-construct";
import SyncCourseModal from "../../../modal/sync-course";
import MultipleContainers from "../tree-course-construct/update/MultipleContainers ";
import { CourseConstructionStore } from "../../../../stores/stores";

type Prop = {
  dataConfig: any;
  sections: Section[];
  detailData: ConstructCourseDetailType;
  handleGetDetail: any;
  paramId: number | string | undefined;
  setSections: any;
};

const CourseConstruct = (props: Prop) => {
  const { t } = useTranslation();
  const { sections, detailData, handleGetDetail, dataConfig } = props;
  const { id } = useParams()
  const { setSectionsState } = CourseConstructionStore();

  const infoData: ConstructCourseDetailType = {
    createDate: detailData.createDate ?? "Chưa có dữ liệu",
    progress: detailData.progress ?? "Chưa có dữ liệu",
    constructVariable: detailData.constructVariable ?? "Chưa có dữ liệu",
  };

  const [isOpenSyncCourseModal, setIsOpenSyncCourseModal] = useState<boolean>(false);
  const [syncCourseCheckbox, setSyncCourseCheckbox] = useState<boolean>(false);
  const [clearForm, setClearForm] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true)

  const convertObjectData = Object.entries(infoData);

  const renderSwitch = (value: string) => {
    switch (value) {
      case "createDate":
        return <div>{t("Ngày bắt đầu", "Ngày bắt đầu")}</div>;
      case "progress":
        return <div>{t("Tiến độ học", "Tiến độ học")}</div>;
      case "constructVariable":
        return <div>{t("Tham số cấu hình", "Tham số cấu hình")}</div>;
      default:
        return "";
    }
  };

  const listInfo = convertObjectData.map((item, index) => (
    <div className="list-item" key={index}>
      <Typography.Title level={5} className="list-item--title">
        {renderSwitch(item[0])}
      </Typography.Title>
      <div className="list-item--description">
        {item[0] === "createDate" ? (
          <Typography.Text className="content">
            {formatDate(item[1])}
          </Typography.Text>
        ) : item[0] === "progress" ? (
          <Typography.Text className="content-progress">
            {item[1]}
          </Typography.Text>
        ) : (
          <Typography.Text className="content">{item[1]}</Typography.Text>
        )}
      </div>
    </div>
  ));

  const confirmModal = () => {
    handleGetDetail()
  };

  const saveSyncCourse = async (coursePlanId: number, isSync: boolean) => {
    const data = {
      courseId: detailData?.id ?? "",
      coursePlanId: coursePlanId,
      isSync: isSync,
    };
    await syncSource(data).then((res) => {
      if (res.status === 200) {
        message.success(t("Khoá học đã được đồng bộ thành công", "Khoá học đã được đồng bộ thành công"));
        handleGetDetail()
        setIsOpenSyncCourseModal(false);
        setClearForm(true);
      }
    });
  };

  const handleOrderChange = async (newOrder: any) => {
    const dataApi = {
      sections: newOrder,
    };
    try {
      await putUpdateCoursePosition(Number(id), dataApi)
      handleGetDetail();
    } catch (error) {
    }
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);


  useEffect(() => {
    setSectionsState(sections);
  }, [sections]);
  const handleOrderChangeMemo = useCallback(handleOrderChange, [id]);

  return (
    <>

      <Form.Provider onFormFinish={(name, { values, forms }) => {
        if (name === "create-sync-course-modal") {
          Modal.confirm({
            title: `Xác nhận đồng bộ`,
            content: `Bạn có chắc chắn muốn đồng bộ khoá học này?`,
            onOk: () => {
              saveSyncCourse(values.lecturerName, syncCourseCheckbox);
            },
            okText: t("Xác nhận", "Xác nhận"),
            cancelText: t("Huỷ", "Huỷ"),
            centered: true,
            icon: <ExclamationCircleOutlined style={{ color: "#1677FF" }} />,
            footer: (_, { OkBtn, CancelBtn }) => (
              <>
                <CancelBtn />
                <OkBtn />
              </>
            ),
          });
        }
      }}>
        <CustomCard
          title={
            <div className="card-heading--info">
              <div>
                <Typography.Title level={5}>
                  {t("Cấu trúc của khóa học", "Cấu trúc của khóa học")}
                </Typography.Title>
                <Typography.Text className="sub-title">
                  {t("Chi tiết cấu trúc được duyệt của kế hoạch", "Chi tiết cấu trúc được duyệt của kế hoạch")}
                </Typography.Text>
              </div>
              <Button
                onClick={() => {
                  setIsOpenSyncCourseModal(true);
                }}
              >
                {t("Đồng bộ cấu trúc", "Đồng bộ cấu trúc")}
              </Button>
            </div>
          }
          className="card-info--wrapper"
        >
          <div className="list-wrapper-course-construct">{listInfo}</div>
        </CustomCard>
        {/* <TreeCourseConstruct
            dataConfig={dataConfig}
            data={sections}
            name={detailData.name}
            id={detailData.id}
            handleGetDetail={handleGetDetail}
            setSections={setSections}
            paramId={paramId}
          /> */}

        {isLoading ? <>
          {[1, 2, 3].map((_, i) => (
            <Skeleton key={i} active paragraph={{ rows: 3 }} style={{ marginBottom: 24 }} />
          ))}
        </> : (
          <MultipleContainers
            initialData={sections}
            dataConfig={dataConfig}
            onOrderChange={handleOrderChangeMemo}
          />
        )
        }

        <SyncCourseModal
          clearForm={clearForm}
          setSyncCourseCheckbox={setSyncCourseCheckbox}
          title={`Đồng bộ khoá học ${detailData?.name}`}
          open={isOpenSyncCourseModal}
          handleOk={confirmModal}
          handleCancel={() => {
            setIsOpenSyncCourseModal(!isOpenSyncCourseModal);
          }}
        />
      </Form.Provider>
    </>
  );
};

export default CourseConstruct;